module.exports = __webpack_public_path__ + "img/small_whale11.cc10fd2c.jpg";